"use client";

import { FindARepProvider } from "@/providers/FindARep";

export default function Providers({ children }) {
  return <FindARepProvider>{children}</FindARepProvider>;
}
